/**
 * I passi del tutorial guidato della finestra "riepilogo fornitore".
 *
 * E' la finestra che si apre cliccando una pastiglia del calendario, ed e' quella
 * dove si tocca la sostanza: si escludono prodotti, si annulla la preparazione di
 * un ordine cliente, si scarica e si manda il riepilogo al fornitore.
 *
 * Ha un tutorial suo - e non passi dentro quello del calendario - perche' il suo
 * overlay deve vivere dentro la finestra: e' una `v-dialog` che si chiude al
 * primo click fuori, e un tutorial montato fuori la farebbe sparire al primo
 * "Avanti".
 */
const at = name => `[data-tour-scope="order-supplier-detail"] [data-tour="${name}"]`;

export function createOrderSupplierDetailTourSteps() {
	return [
		{
			body: "Questa e' la distinta di quello che va ordinato a un fornitore per una certa data di consegna. Ogni riga e' un prodotto richiesto, e nasce da un ordine cliente vero: la colonna Rif.Ordine dice da quale. Non e' un ordine che parte da solo - qui lo si controlla, si toglie quello che non serve, e poi lo si scarica o lo si manda.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Il riepilogo del fornitore',
		},
		{
			body: "In testa trovi la data di consegna e quanti prodotti compongono la distinta. Nelle colonne: il numero dell'ordine fornitore, il prodotto con il suo SKU, la quantita' e il riferimento all'ordine cliente da cui quella riga viene. Se lo stesso articolo serve a piu' clienti, lo trovi ripetuto su piu' righe.",
			key: 'summary',
			placement: 'bottom',
			target: at('summary'),
			timeout: 250,
			title: 'Come si legge la distinta',
		},
		{
			body: "La spunta rossa toglie quel prodotto dall'ordine senza cancellare niente: la riga resta qui, ma non finisce nel riepilogo che scarichi ne' nella mail che mandi al fornitore. Serve per quello che hai gia' a magazzino o che hai deciso di non riordinare. La spunta si salva subito, non c'e' un pulsante da confermare.",
			key: 'exclude',
			placement: 'right',
			target: at('exclude'),
			timeout: 250,
			title: 'Escludere un prodotto',
		},
		{
			body: "Attenzione a questo, perche' e' il piu' drastico della finestra. Annulla non toglie una riga: annulla la preparazione dell'intero ordine cliente indicato in Rif.Ordine, e lo fa ovunque - se quell'ordine aveva prodotti da tre fornitori diversi, spariscono da tutti e tre. L'ordine cliente torna indietro, come se non fosse mai stato preparato. Chiede conferma, ma poi va rifatto tutto.",
			key: 'rollback',
			placement: 'left',
			target: at('rollback'),
			timeout: 250,
			title: 'Annulla preparazione',
		},
		{
			body: "Scarica riepilogo genera il file della distinta, gia' ripulito: i prodotti che hai escluso e quelli che appartengono a ordini cliente annullati non ci sono. Le righe con lo stesso SKU vengono sommate, cosi' al fornitore arriva una quantita' sola per articolo invece di dieci righe uguali.",
			key: 'download',
			placement: 'top',
			target: at('download'),
			title: 'Scaricare il riepilogo',
		},
		{
			body: "Invia tramite mail manda la stessa distinta direttamente al fornitore, all'indirizzo scritto nella sua anagrafica. Se quel campo e' vuoto l'invio si ferma con un errore e non parte niente: e' il motivo per cui vale la pena tenere l'email compilata nella scheda fornitore.",
			key: 'mail',
			placement: 'top',
			target: at('mail'),
			title: 'Mandarlo al fornitore',
		},
	];
}
